import { forwardRef, RefObject } from 'react';
import CustomTooltip from './CustomTooltip';
import { PlacementType, VariantType } from './types';

interface Props {
  text: string;
  placement: PlacementType;
  variant?: VariantType;
  containerRef?: RefObject<HTMLElement>;
}

export const ButtonTooltip = forwardRef<HTMLButtonElement, Props>(
  ({ text, placement, variant = 'black', containerRef }, ref) => {
    return (
      <CustomTooltip
        text={text}
        anchorRef={ref as RefObject<HTMLElement>}
        placement={placement}
        isTagStyle={false}
        arrow={true}
        variant={variant}
        isOpen={true}
        containerRef={containerRef}
      />
    );
  }
); 